import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Twitter(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <g clipPath='url(#clip0_3518_1600)'>
        <path
          d='M17.7512 3H20.818L14.1179 10.6577L22 21.0782H15.8284L10.9946 14.7582L5.46359 21.0782H2.39494L9.5613 12.8874L2 3H8.32828L12.6976 8.77667L17.7512 3ZM16.6748 19.2425H18.3742L7.4049 4.73921H5.58133L16.6748 19.2425Z'
          fill='currentColor'
        />
      </g>
      <defs>
        {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
        <clipPath id='clip0_3518_1600'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </BaseLibraryIconSvg>
  );
}
